<div>
  <div class="row">
    <!-- Here header will come -->
  </div>
  <form [formGroup]="resetPasswordForm">
    <div class="card">
      <h4 class="card--heading">{{ 'reset_password_text' | translate }}</h4>
      <h3 class="card--quote">
        {{ 'reset_password_info_text' | translate }}
      </h3>
      <div class="card-form">
        <!-- New Password Field -->
        <div class="form-row">
          <mat-form-field>
            <input
              [type]="!isPasswordVisible ? 'password' : 'text'"
              matInput
              autocomplete="new-password"
              id="new-password"
              formControlName="password"
              placeholder="{{ 'placeholder.new_password' | translate }}"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="isPasswordVisible = !isPasswordVisible"
            >
              <mat-icon>{{
                !isPasswordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </button>
            <mat-error *ngIf="resetPasswordForm.get('password').touched">
              <ng-container
                *ngIf="resetPasswordForm.get('password').hasError('required')"
              >
                Password is required.
              </ng-container>
              <ng-container
                *ngIf="
                  resetPasswordForm.get('password').hasError('invalidLength')
                "
              >
                Password length should be between 8 and 20 characters.
              </ng-container>
              <ng-container
                *ngIf="
                  resetPasswordForm.get('password').hasError('noUppercase')
                "
              >
                Password should contain at least one uppercase letter.
              </ng-container>
              <ng-container
                *ngIf="
                  resetPasswordForm.get('password').hasError('noLowercase')
                "
              >
                Password should contain at least one lowercase letter.
              </ng-container>
              <ng-container
                *ngIf="resetPasswordForm.get('password').hasError('noNumeric')"
              >
                Password should contain at least one numeric value.
              </ng-container>
              <ng-container
                *ngIf="
                  resetPasswordForm.get('password').hasError('invalidCharacter')
                "
              >
                Password contains invalid characters.
              </ng-container>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Confirm Password Field -->
        <div class="form-row">
          <mat-form-field>
            <input
              [type]="!isConfirmPasswordVisible ? 'password' : 'text'"
              matInput
              formControlName="resetPassword"
              placeholder="{{ 'placeholder.confirm_password' | translate }}"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible"
            >
              <mat-icon>{{
                !isConfirmPasswordVisible ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </button>
            <mat-error *ngIf="resetPasswordForm.get('resetPassword').touched">
              <ng-container
                *ngIf="
                  resetPasswordForm.get('resetPassword').hasError('required')
                "
              >
                {{ 'validation.confirm_password' | translate }}
              </ng-container>
              <ng-container
                *ngIf="
                  resetPasswordForm
                    .get('resetPassword')
                    .hasError('passwordMatch') &&
                  resetPasswordForm.get('password').value &&
                  resetPasswordForm.get('resetPassword').touched
                "
              >
                {{ 'validation.password_not_match' | translate }}
              </ng-container>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="card-footer" (click)="resetPassword()">
        <button class="login" mat-button>
          <i *ngIf="isResetingIn" class="fa fa-spinner fa-spin"></i>
          {{ 'button.save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
